import AuthPage from '../../AuthPage';

function OgretmenGirisPage() {
  return (
    <AuthPage 
      role="teacher"
      title="Teacher Login"
      icon="👨‍🏫"
      redirectPath="/teacher"
    />
  );
}

export default OgretmenGirisPage;